<template>
  <b-modal
    v-if="projectId"
    id="modal-hotalert-filter"
    :no-close-on-backdrop="true"
    :no-close-on-esc="false"
    :title="$t('Advanced Filter')"
    size="lg"
    :ok-title="$t('Apply')"
    :close-title="$t('Cancel')"
    @ok="handleOk"
  >
    <form-filter
      v-if="projectId"
      v-model="filterConfig.filters"
      :project-id="projectId"
    />

  </b-modal>
</template>

<script>
import FormFilter from '@/layouts/components/forms/FormFilter.vue'

import {
  BModal, VBModal,
} from 'bootstrap-vue'

export default {
  components: {
    BModal,
    FormFilter,
  },
  directives: {
    'b-modal': VBModal,
  },
  props: {
    projectId: {
      type: [Number, String],
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  computed: {
    filterConfig: {
      get() {
        return this.value
      },
    },
  },
  mounted() {
    this.$root.$on('hotalert_filter', () => {
      this.$nextTick(() => {
        this.$bvModal.show('modal-hotalert-filter')
      })
    })
  },
  beforeDestroy() {
    this.$root.$off('hotalert_filter')
  },
  methods: {
    handleOk() {
      this.$emit('refreshHotalertList', this.filterConfig)
      this.$bvModal.hide('modal-hotalert-filter')
    },
  },
}
</script>
